import React from "react";
import Slider from "react-slick";
import "./Partner.css";

export default function Partner() {
  const universities = [
    { name: "Subharti University", logo: "/images/U1.jpg" },
    { name: "IGNOU", logo: "/images/U2.jpg" },
    { name: "Andhra University", logo: "/images/U3.jpg" },
    { name: "Amity University", logo: "/images/U4.jpg" },
    { name: "Lovely Professional University (LPU)", logo: "/images/U5.jpg" },
    { name: "Sikkim Manipal University", logo: "/images/Ignou0.jpg" },
    { logo: "/images/andhra.png" },
    { logo: "/images/CCSU-Logo.jpg" },
    { logo: "/images/vignan-logo.03d83441.webp" },
    { logo: "/images/vgu_logo.png" },
    { logo: "/images/upgrad-header-logo.325f003e.svg" },
    { logo: "/images/upes-logo-black.avif" },
    { logo: "/images/university_print.webp" },
    { logo: "/images/top-logo.png" },
    { logo: "/images/svsu-logo.webp" },
    { logo: "/images/su-naac-white.webp" },
    { logo: "/images/srmonline-logo-blue-2048x641.png" },
    { logo: "/images/sikkimManipal.jpg" },
    { logo: "/images/parul.webp" },
    { logo: "/images/nmims-university-logo.png" },
    { logo: "/images/mizoram.jpg" },
    { logo: "/images/manipal1.webp" },
    { logo: "/images/mangalayatan.webp" },
    { logo: "/images/LPU-Online-Logo.svg" },
    { logo: "/images/logo-GU-online.png" },
    { logo: "/images/logo-bosse.webp" },
    { logo: "/images/logo.png" },
    { logo: "/images/gla-logo.png" },
    { logo: "/images/dyp-online-logo.png" },
    { logo: "/images/download.webp" },
    { logo: "/images/ddugu-logo.png" },
    { logo: "/images/cu-logo.webp" },
    { logo: "/images/CCSU-logo.jpg" },
    { logo: "/images/amity_logo_c_White_ffbfeced80.svg" },
    { logo: "/images/24_onlineUU.png" },
  ];

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="partner-wrapper">
      <div className="partner-section">
        <h1 className="partner-title">Our Partner Universities</h1>
        <p className="partner-desc">
          In Bangalore, there are many different distance education providers
          offering a variety of courses. Here are some of the top distance
          education providers in Bangalore.
        </p>

        <Slider {...settings}>
          {universities.map((uni, index) => (
            <div key={index} className="logo-container">
              <img src={uni.logo} alt={uni.name || "University"} />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
